export default "__VITE_ASSET__BvGzpGwa__"